import React, { Component } from 'react'
import { SvgVip } from '../Svg'
/**
 * 用户中心组件
 */
class Vip extends Component {
    static defaultProps = {
      iconData: {
        url: '//vip.youku.com/',
        title: 'VIP',
        className: 'ico-vip'
      }
    }
    render () {
      return (
        <div className='u-vip'>
          <div className='handle'>
            <a href={this.props.iconData.url} target='_blank' rel='noopener noreferrer'>
              <SvgVip /><br />
              {this.props.iconData.title}</a>
          </div>
        </div>
      )
    }
}
export default Vip
